export class MailData {
  email!:string;
  ime!:string;
  prezime!:string;
  jmbg!:string;
  consent:boolean = false;
  temp:string="MPS";
  lang:string ="sr";
  calc!:number
}
